import { useEffect, useState } from "react";
import RecordPanel from "./RecordPanel";
// import RecordTitle from "./RecordTitle";
import { message } from "antd";
import timingStore, {
  disabledRecordStatus,
  RecordStatus,
} from "@/store/timing.store";
import { Navigate } from "react-router-dom";
import RecordTip from "./RecordTip";
import { RuningInLink } from "@/constants";

import Dialog from "@/component/Dialog";
import { handleStopRecording, handleStopRecordingWithoutPermission } from "@/utils/recordingHandler";
import { CompanyErrorTopic } from "@/constants/im";
import { im } from "@core/ability";
import { IS_PRIVATE } from "@/config";

export default function Record() {

  const [showDialog, setShowDialog] = useState(false);

  // await handleStopRecording();
  useEffect(() => {
    window.history.pushState(null, '', document.URL);
    window.onpopstate = handlePageBack;
    window.onbeforeunload = () => {
      if (disabledRecordStatus.includes(timingStore.getState().recordStatus)) {
        message.warning("会议记录录制中，请先结束录制再关闭应用");
        return false;
      }
    };
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  useEffect(() => {
    // 私有化状态下不需要监听企业错误
    if (IS_PRIVATE) {
      return;
    }
    
    // 监听当前登录企业被踢出，则重新跳转到登录页选择组织
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const companyErrorTopicCb = (message: any) => {
      console.log(`record page onmessage ${CompanyErrorTopic}`, message);
      handleCompanyError();
    };
    im.subscribe(CompanyErrorTopic, companyErrorTopicCb);

    const handleCompanyError = () => {
      handleStopRecordingWithoutPermission();
    };
    return () => {
      im.unsubscribe(CompanyErrorTopic, companyErrorTopicCb);
    };
  }, [])
  

  const handlePageBack = (event: PopStateEvent | BeforeUnloadEvent) => {
    event.preventDefault();
    window.history.pushState(null, '', document.URL);
    setShowDialog(true);
    return "";
  }

  // Redirect to home page if the record status is not started
  if (timingStore.getState().recordStatus === RecordStatus.UNSTART) {
    return <Navigate to="/" replace={true} />;
  }

  return (
    <div className="h-full flex flex-col">
      <Dialog
        isOpen={showDialog}
        title="确定结束"
        content="结束后将进入记录详情页"
        confirmText="确认"
        onCancel={() => {
          setShowDialog(false);
        }}
        onConfirm={async () => {
          setShowDialog(false);
          await handleStopRecording();
          window.onpopstate = null;
        }}></Dialog>

      {/* <RecordTitle /> */}
      <RecordTip />
      <div className={`h-full flex flex-col items-center`}>
        <div className={`${RuningInLink ? 'h-3' : 'h-12'}`}></div>
        <RecordPanel />
      </div>
    </div>
  );
}
